export default "/images/15 Step3TakeAction-Provider-To access tips and materials-02.png?4713f67a4ade692ecdc985078cfe2d73";